import React from 'react';
import { Redirect } from 'react-router-dom';
import ModalFullscreen from '../ModalFullscreen';
import FeedbackHelpContainer from '../FeedbackHelpContainer';
import generateReportUrl from '../../utils/reports/generateReportUrl';
import ModalFullscreenStore from '../../flux/ModalFullscreenStore';
import { feedbackCommonProperties } from '../../flux/ModalFullscreenActions';

export default function StoreSuggestion({
  data,
  match,
}) {
  const redirectBackUrl = generateReportUrl(match.params.collectionType, match.params);

  const firstUserInStore = data.find(row => (
    row.store_id === match.params.store &&
    row.country === match.params.country &&
    row.region_code === match.params.region
  ));

  if (firstUserInStore === undefined) {
    return (
      <Redirect to={redirectBackUrl} />
    );
  }

  const boutique = firstUserInStore.store_name;

  return (
    <ModalFullscreen
      isOpen={true}
      isLoading={false}
    >
      <FeedbackHelpContainer>
        <iframe
          title="suggestion-modal"
          src={ModalFullscreenStore.getModalReportProblemStoreUrl({ ...feedbackCommonProperties(), boutique })}
          frameBorder="0"
          style={{ fontSize: 0 }}
        />
      </FeedbackHelpContainer>
    </ModalFullscreen>
  );
}
